import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Form, Surface, Txt } from '@vst/beam';
import { useTranslation } from 'react-i18next';

import { useScreenResolution } from '@app/hooks';
import { selectBillingAccount, triggerBillCycleDayUpdate } from '@app/redux';
import { setOldBillCycleDay } from '@app/redux/updateBillCycle';

import { CurrentBillDate } from '../current-bill-date';
import { DateSelect } from '../date-select';
import { InfoNotice } from '../info-notice';
import ProrateNotice from '../prorate-notice';

import styles from './styles.module.scss';

export const ChangeBillDateForm = ({ handleCancel }: { handleCancel: () => void }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation('UpdateBillCycle');

  const { isSmall, isExtraSmall } = useScreenResolution();
  const isMobile = isSmall || isExtraSmall;

  const billingAccount = useSelector(selectBillingAccount);

  const [selectedOption, setSelectedOption] = useState('');

  const handleSubmit = (e: any) => {
    e.preventDefault();
    // Persist the current (old) billing cycle day for use on success screen
    if (billingAccount?.billingCycleDayOfMonth != null) {
      dispatch(setOldBillCycleDay(Number(billingAccount.billingCycleDayOfMonth)));
    } else {
      dispatch(setOldBillCycleDay(null));
    }
    dispatch(triggerBillCycleDayUpdate(Number(selectedOption)));
  };

  return (
    <Form
      onSubmit={handleSubmit}
      initialValues={{ select: selectedOption }}
      validationMode="onSubmit"
      className={styles['form']}
    >
      <Surface className={styles['form-body']}>
        <Txt data-cy="title" variant="heading4">
          {t('title')}
        </Txt>
        <CurrentBillDate />
        <DateSelect setSelectedOption={setSelectedOption} selectedOption={selectedOption} />
        <InfoNotice />
        {selectedOption && billingAccount?.billingCycleDayOfMonth && (
          <ProrateNotice
            newBillCycleDay={Number(selectedOption)}
            oldBillCycleDay={billingAccount?.billingCycleDayOfMonth}
          />
        )}
      </Surface>
      <hr />
      <Surface className={styles['form-footer']} data-cy="form-footer">
        <Button data-cy="cancel" variant="secondary" onClick={handleCancel} fluid={isMobile} type="button">
          {t('buttons.cancel')}
        </Button>
        <Button
          type="submit"
          data-cy="submit"
          variant="primary"
          fluid={isMobile}
          width={isMobile ? undefined : '223px'}
        >
          {t('buttons.submit')}
        </Button>
      </Surface>
    </Form>
  );
};
